@for (toggle of togglesCollapsed; track toggle) {
<div class="product-toggles">
    @if (getToggleValue(toggle.name) && (toggle.staticTitle ?? getToggleValue(toggle.name + fragmentlabelTitle))) {
    <h-expansion-panel
        id="{{ 'product-toggle-' + toggle.name }}"
        class="product-toggle"
        [contentPadding]="'17px 0 0 1px'"
        [collapsed]="toggle.collapsed"
        [expansionPanelId]="toggle.name"
        (collapsedChange)="onCollapsedChange($event)"
        [backgroundColor]="backgroundColor">
        <ng-template hExpansionPanelPart="header">
            <span
                class="heading-4 display-light"
                [innerHTML]="
                    toggle.staticTitle
                        ? (toggle.staticTitle | translate)
                        : getToggleValue(toggle.name + fragmentlabelTitle)
                ">
            </span>
        </ng-template>
        <ng-template hExpansionPanelPart="content">
            <div
                class="product-toggle-content {{ 'product-toggle-' + toggle.name }} paragraph-small"
                [innerHTML]="productToggles[toggle.name]">
            </div>
        </ng-template>
    </h-expansion-panel>
    }
</div>
}
